import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { closeAlert } from "actions/common/alert";
import Alert from "components/common/Alert";

const mapStateToProps = ({ alert: { message, visible } }) => ({
  message,
  visible
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      closeAlert
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Alert);



// WEBPACK FOOTER //
// ./src/containers/common/Alert/index.js